<div class="ml-3 h-0 min-h-full rounded-lg bg-gray-4 p-5 shadow-md">
  <mat-tab-group
    mat-stretch-tabs="false"
    mat-align-tabs="start"
    class="h-full"
    [selectedIndex]="selectedTabIndex()"
    (selectedTabChange)="onTabChange($event)"
  >
    <mat-tab [label]="'Профіль'">
      <chat-user-profile
        [member]="member()"
        [memberProfileComments]="chatState.memberComments()"
        [memberContracts]="member().contracts"
      ></chat-user-profile>
    </mat-tab>
    <mat-tab [label]="'Призначення'">
      <chat-prescriptions-list
        #prescriptionList
        [member]="member()"
      ></chat-prescriptions-list>
    </mat-tab>
  </mat-tab-group>
</div>
